import React from 'react'
import { StaticQuery, graphql, Link } from "gatsby";


class CollectionNavbarElement extends React.Component{
    render(){
        return(<li className="dropNavItem mainThing firstElement thatNotLink boldDropDown"><p className="dropTextItem">{this.props.title}</p></li>);
    }
}
export default CollectionNavbarElement